const mapHeroSectionData = (data) => {
  const { hero, diagnostics_page_partner: partner, og_meta } = data || {};

  const heroSectionData = {};

  heroSectionData.banner = hero?.hero_background;
  heroSectionData.subtitle = hero?.hero_subtitle;
  heroSectionData.title = hero?.hero_title;
  heroSectionData.ctaTitle = hero?.hero_cta_title;
  heroSectionData.partnerLogo = partner?.image;
  heroSectionData.partnerLogoWidth = partner?.description;
  heroSectionData.ogMeta = og_meta;

  return heroSectionData;
};

const mapHowItWorksData = (data) => {
  const { features_and_benefits: howItWorks } = data || {};

  const howItWorksData = {};

  howItWorksData.title = howItWorks?.title;
  howItWorksData.list = howItWorks?.components?.map(({ title }) => ({
    text: title,
  }));

  return howItWorksData;
};

const mapFormsData = (data) => {
  const { forms } = data || {};

  const formsData = {};

  const pageType = forms?.page_type;

  const isYogaPage = pageType === "YOGA_PARTNERSHIP";
  const isNutritionPage = pageType === "NUTRITION_PARTNERSHIP";
  const isHealthPage = pageType === "HEALTH_PARTNERSHIP";
  const isDermaPage = pageType === "DERMA_PARTNERSHIP";

  formsData.showHeader = forms?.show_header;
  formsData.isMainWebsitePage = forms?.is_main_website_page;

  // Page Type
  formsData.pageType = pageType;
  formsData.isYogaPage = isYogaPage;
  formsData.isNutritionPage = isNutritionPage;
  formsData.isHealthPage = isHealthPage;
  formsData.isDermaPage = isDermaPage;

  // Form Title Subtitle
  formsData.formTitle = forms?.sub_title;
  formsData.formSubtitle = forms?.description;

  // Show / Hide Fields
  formsData.showNameField = forms?.show_name_field;
  formsData.showCVIDField = forms?.show_cvid_field;
  formsData.showPhoneField = forms?.show_phone_field;
  formsData.showEmailField = forms?.show_email_field;
  formsData.showCompanyNameField = forms?.show_company_field;
  formsData.showGoalField = forms?.show_goal_field;
  formsData.showDermaTypeField = forms?.show_derma_type_field;
  formsData.showSelectPackage = forms?.show_select_package_field;
  formsData.showPromoCodeField = forms?.accept_coupon;
  formsData.showReferralField = forms?.accept_referral;
  formsData.showAllPackages = isNutritionPage && forms?.show_all_packages;

  // Placeholders
  formsData.namePlaceHolder = forms?.namePlaceHolder;
  formsData.cvidPlaceholder = forms?.cvidPlaceholder;
  formsData.mobilePlaceholder = forms?.mobilePlaceholder;
  formsData.emailPlaceholder = forms?.emailPlaceholder;
  formsData.companyNamePlaceholder = forms?.companyNamePlaceholder;
  formsData.goalPlaceholder = forms?.goalPlaceholder;
  formsData.dermaTypePlaceholder = forms?.dermaTypePlaceholder;
  formsData.selectedPackagePlaceholder = forms?.selectedPackagePlaceholder;
  formsData.promoCodePlaceholder = forms?.promoCodePlaceholder;
  formsData.referralCodePlaceholder = forms?.referralCodePlaceholder;

  // Discount
  formsData.discount = forms?.default_percent;

  formsData.packagePageType = forms?.package_page_type;

  const serviceMap = {
    YOGA_PARTNERSHIP: "yoga",
    NUTRITION_PARTNERSHIP: "nutrition",
    HEALTH_PARTNERSHIP: "health_program",
    DERMA_PARTNERSHIP: "derma",
  };

  // Options
  const services =
    Array.isArray(forms?.services) &&
    forms?.services?.find(({ value }) => value === serviceMap[pageType]);

  formsData.options =
    services?.slugs?.map(({ label, slug, related_nutrition_goals_ids }) => ({
      label,
      value: slug,
      id: related_nutrition_goals_ids?.[0],
    })) || [];

  formsData.dermaTypeOptions = forms?.derma_type_options;

  formsData.isRequestCallbackPage = forms?.is_request_callback_page;
  formsData.defaultSelectedPackDuration = forms?.default_selected_pack_duration;
  formsData.isFreeTrialPage = forms?.is_free_trial_page;

  // Class Info
  formsData.classInfo = forms?.trial_class_info;

  // Request Callback Button
  if (forms?.request_callback)
    formsData.needMoreInfo = forms?.secondary_cta_text;

  // Callback UI
  formsData.callbackSuccessTitle = forms?.submission_title;
  formsData.callbackSuccessSubtitle = forms?.submission_subtitle;
  formsData.showAppDownLoadButtonLink = forms?.show_app_download_links;

  const defaultAmountMap = {
    YOGA_PARTNERSHIP: 49,
    NUTRITION_PARTNERSHIP: 99,
    HEALTH_PARTNERSHIP: 99,
    DERMA_PARTNERSHIP: 499,
  };

  // Pricing
  const currency = services?.currency_code || "INR";
  const amount = Number(services?.amount) || defaultAmountMap[pageType];

  formsData.priceConstant = `Try for ${currency} `;
  formsData.price = {
    currency,
    priceprices: { trial: amount },
    price: amount,
  };

  // Default Adset Name
  formsData.defaultAdsetName = forms?.adset_name;

  const defaultSlugMap = {
    YOGA_PARTNERSHIP: "yoga-for-others-ind-49",
    NUTRITION_PARTNERSHIP: "nutrition-callback-others",
    HEALTH_PARTNERSHIP: "health-for-others-ind-49",
    DERMA_PARTNERSHIP: "derma-callback-others",
  };

  // Default Package Slug
  const packageSlug = forms?.package_slug;
  formsData.defaultPackageSlug = packageSlug || defaultSlugMap[pageType];

  // Default Timezone
  formsData.defaultTimezone = forms?.default_timezone;
  formsData.defaultUrlArguments = forms?.default_url_arguments || {};

  return formsData;
};

const mapHealthConditionData = (data) => {
  const { highlights, floating_banner: aboutUs } = data || {};
  const healthConditionData = {};

  healthConditionData.aboutTitle = aboutUs?.title;
  healthConditionData.aboutSubtitle = aboutUs?.subtitle;

  healthConditionData.title = highlights?.title;
  healthConditionData.ctaTitle = highlights?.description;
  healthConditionData.healthConditions = highlights?.components?.map(
    ({ image, title, url }) => ({
      img: image,
      text: title,
      link: url,
    })
  );

  return healthConditionData;
};

const mapTestimonialsData = (data) => {
  const { testimonials } = data;
  const testimonialsData = {};

  testimonialsData.title = testimonials?.title || "";
  testimonialsData.testimonials =
    testimonials?.components?.map(
      ({ title: userName, sub_title: comment, image }) => ({
        userName,
        comment,
        image,
      })
    ) || [];

  return testimonialsData;
};

const mapPartnershipData = (data) => {
  const partnershipData = {};

  partnershipData.hero = mapHeroSectionData(data);
  partnershipData.howItWorks = mapHowItWorksData(data);
  partnershipData.forms = mapFormsData(data);
  partnershipData.healthConditions = mapHealthConditionData(data);
  partnershipData.testimonials = mapTestimonialsData(data);

  return partnershipData;
};

export default mapPartnershipData;
